/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Test_Title4Inputs */

const en_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing with real clients`)
};

const ar_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاختبار مع عملاء حقيقيين`)
};

const bn_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসল ক্লায়েন্টে টেস্টিং`)
};

const de_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tests mit echten Clients`)
};

const es_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruebas con clientes reales`)
};

const fr_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tests avec de vrais clients`)
};

const pt_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testes com clientes reais`)
};

const zh_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用真实客户端测试`)
};

const tr_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek istemcilerle test`)
};

const ru_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тесты на реальных клиентах`)
};

const pl_svc_mcp_server_development_test_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Test_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testy na prawdziwych klientach`)
};

/**
* | output |
* | --- |
* | "Testing with real clients" |
*
* @param {Svc_Mcp_Server_Development_Test_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_test_title4 = /** @type {((inputs?: Svc_Mcp_Server_Development_Test_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Test_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_test_title4(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_test_title4(inputs)
	if (locale === "de") return de_svc_mcp_server_development_test_title4(inputs)
	if (locale === "es") return es_svc_mcp_server_development_test_title4(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_test_title4(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_test_title4(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_test_title4(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_test_title4(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_test_title4(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_test_title4(inputs)
	return en_svc_mcp_server_development_test_title4(inputs)
});
export { svc_mcp_server_development_test_title4 as "svc_mcp-server-development_TEST_title" }